import { jsxs } from "react/jsx-runtime";
import { Span } from "../Text/Span.js";
const CarouselSlideNumText = ({ currentSlide, totalSlides, numbersClasses = '', ...props })=>/*#__PURE__*/ jsxs(Span, {
        textStyle: "body3",
        palette: "neutral",
        shade: "1",
        className: numbersClasses,
        "data-testid": "carousel-numbers-text",
        ...props,
        children: [
            currentSlide,
            " / ",
            totalSlides
        ]
    });
export { CarouselSlideNumText };
